export default __webpack_public_path__ + "static/media/eye-fill.9fcb37b7.svg";